<template>
  <div class="mb-5">
    <h4 class="mt-3">{{ $t("PERFORMED_OPERATIONS") }}</h4>

    <v-row class="t-head">
      <v-col>{{ $t("DATE") }}</v-col>
      <v-col>{{ $t("OPERATION") }}</v-col>
      <v-col>{{ $t("COUNT") }}</v-col>
      <v-col>{{ $t("OPERATOR") }}</v-col>
      <v-col>{{ $t("CORRECTION") }}</v-col>
      <v-col>{{ $t("DELETE") }}</v-col>
    </v-row>
    <template v-for="operation in routemap.operations">
      <v-row class="row border-bottom" v-bind:key="'oo' + operation.id">
        <v-col class="t-row">{{ operation.date }}</v-col>
        <v-col class="t-row">{{ operation.operation }}</v-col>
        <v-col class="t-row">{{ operation.quantity }}</v-col>
        <v-col class="t-row"
          >{{ operation.operator }}
          <i v-if="operation.edited_by > 0">{{ $t("CORRECTED") }}</i>
        </v-col>
        <v-col class="t-row">
          <span
            v-if="['Admin', 'Qualified', 'Manager'].includes(user.role)"
            class="btn btn-block btn-danger"
            @click="handleEditOperationClicked(operation)"
            >{{ $t("MODIFY") }}</span
          >
        </v-col>
        <v-col class="t-row">
          <span
            v-if="['Admin', 'Qualified', 'Manager'].includes(user.role)"
            class="btn btn-block btn-danger"
            @click="handleDeleteOperationClicked(operation.id)"
            >{{ $t("DELETE") }}</span
          >
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
export default {
  name: "PerformedOperationsSection",
  props: {
    routemap: {
      required: true,
    },
    user: {
      required: true,
      type: Object,
    },
  },

  methods: {
    handleEditOperationClicked(operation) {
      if (
        this.routemap.status > 5 &&
        !["Admin", "Qualified"].includes(this.user.role)
      ) {
        return;
      }

      this.$emit("edit-operation", operation);
    },

    handleDeleteOperationClicked(operationId) {
      if (
        this.routemap.status > 5 &&
        !["Admin", "Qualified"].includes(this.user.role)
      ) {
        return;
      }

      this.$emit("delete-operation", operationId);
    },
  },
};
</script>

<style scoped></style>
